<template>
  <div class="pay-page">
    <img src="../assets/logo.png" alt="LOGO" />
    <h2>Выберите время услуги</h2>
    <PayForm />
  </div>
</template>

<script>
// @ is an alias to /src
import PayForm from '@/components/PayForm'

export default {
  name: 'Pay',
  components: {
    PayForm
  }
}
</script>

<style>
.pay-page {
  width: 100%;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pay-page h2 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: 500;
  line-height: 40px;
  color: #e7a61a;
}

.pay-page img {
  width: 100%;
  max-width: 400px;
  margin-bottom: 10px;
}
</style>
